module.exports = __webpack_public_path__ + "img/sv23.ac3d657b.svg";